import { useMemo, useState, useCallback } from 'react';

// ----------------------------------------------------------------------

export function useBoolean(defaultValue) {
  const [value, setValue] = useState(!!defaultValue);

  const onTrue = useCallback(() => {
    setValue(true);
  }, []);

  const onFalse = useCallback(() => {
    setValue(false);
  }, []);

  const onToggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);

  const onCloseNotBackdrop = useCallback((event, reason) => {
    if (reason !== 'backdropClick') {
      setValue(false);
    }
  }, []);

  return useMemo(
    () => ({
      value,
      onTrue,
      onFalse,
      onToggle,
      setValue,
      onCloseNotBackdrop,
    }),
    [value, onTrue, onFalse, onToggle, setValue, onCloseNotBackdrop]
  );
}
